import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import styles from './style.module.scss';
import {useStore} from '@/store/root-store';
import {notification as antdNotification} from 'antd';
import {useRouter} from 'next/navigation';
import styled from 'styled-components';
import {NoSsr} from '@/components/common-components';
import {getTokenFromCookies} from '@/api/common-utils';
import UserMenu from '../user-menu';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChartLineUp} from '@fortawesome/pro-duotone-svg-icons';

const Header = observer(() => {
  const router = useRouter();
  const {settings: {customer: {loadProfile}}} = useStore('');
  const token = getTokenFromCookies();
  useEffect(() => {
    if (token ) {
      loadProfile();
    }
  }, [token]);

  useEffect(() => {
    antdNotification.destroy();
  }, [router]);

  const {settings: {customer: {profile}}} = useStore('');

  return (<NoSsr>
    <WrapperMain>
      <div
        className={``}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <Icon icon={faChartLineUp} width={22} />
          <p style={{paddingLeft: '5px'}}>Diagonal Growth</p>
        </div>
      </div>

      <div className={styles['header__user-menu']}>
        <UserMenu name={profile.fullName}/>
      </div>
    </WrapperMain>
  </NoSsr>
  );
});

export default Header;

const WrapperMain = styled.div`
  position: fixed;
  width: 100%;
  display: flex;
  padding-left: 28px;
  height: auto;
  z-index: 999;
  justify-content: space-between;
  background: #fff !important;
`;

const Icon = styled(FontAwesomeIcon)`
  font-size: 20px !important;
  margin-right: 5px !important;
  /* padding-right: 17px; */
 
`;


